export default __webpack_public_path__ + "static/media/missions.9ff6b961.svg";